import axios from 'axios';
import * as actionTypes from './brandActionTypes';
import { apiTimeout } from '../error';
import { STATIC_PUBLIC_BRANDS } from '../../constants/staticPublicBrands';

const { REACT_APP_API_URL } = process.env;

/** Placeholder / junk brands that should never appear on the public site. */
const JUNK_BRAND_RE = /^(test|demo|sample|asdf|xxx)$/i;

function normalizeBrandList(data) {
  const rows = Array.isArray(data) ? data : data?.rows;
  return Array.isArray(rows) ? rows : [];
}

function isJunkBrand(brand) {
  const name = String(brand?.name || '').trim();
  const slug = String(brand?.slug || '').trim();
  return JUNK_BRAND_RE.test(name) || JUNK_BRAND_RE.test(slug);
}

/**
 * Keep active, non-junk brands. Enrich missing logos from static defaults by slug/name.
 */
export function filterPublicBrands(list) {
  const staticByKey = new Map();
  STATIC_PUBLIC_BRANDS.forEach((b) => {
    staticByKey.set(String(b.slug || '').toLowerCase(), b);
    staticByKey.set(String(b.name || '').toLowerCase().replace(/\s+/g, ''), b);
  });

  return (list || [])
    .filter((b) => b && Number(b.status) !== 0 && !isJunkBrand(b))
    .map((b) => {
      const slugKey = String(b.slug || '').toLowerCase();
      const nameKey = String(b.name || '').toLowerCase().replace(/\s+/g, '');
      const fallback = staticByKey.get(slugKey) || staticByKey.get(nameKey);
      if (!fallback) return b;
      return {
        ...b,
        logoWithBg: b.logoWithBg || fallback.logoWithBg,
        logoTransparent: b.logoTransparent || fallback.logoTransparent,
        description: b.description || fallback.description,
      };
    });
}

function dispatchBrandSuccess(dispatch, list) {
  dispatch({
    type: actionTypes.GET_PUBLIC_BRANDS_SUCCESS,
    payload: { data: list },
  });
  return list;
}

/**
 * Active brands for public site (logos, slug, name) — no auth.
 * Always fetches fresh (cache-busted). Falls back to STATIC_PUBLIC_BRANDS when empty/unavailable.
 */
export const getPublicBrands = () => {
  return (dispatch) => {
    dispatch({ type: actionTypes.GET_PUBLIC_BRANDS });
    return apiTimeout(
      axios.get(`${REACT_APP_API_URL}/brand/get`, {
        params: { _t: Date.now() },
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
        },
      })
    )
      .then((response) => {
        const list = filterPublicBrands(normalizeBrandList(response.data?.data));
        if (list.length === 0) {
          return dispatchBrandSuccess(dispatch, STATIC_PUBLIC_BRANDS);
        }
        return dispatchBrandSuccess(dispatch, list);
      })
      .catch(() => {
        return dispatchBrandSuccess(dispatch, STATIC_PUBLIC_BRANDS);
      });
  };
};
